import React, { useState } from "react";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import { FormattedMessage, injectIntl } from "react-intl";
import Accordion from 'react-bootstrap/Accordion';
import { useDispatch, useSelector } from "react-redux";
import ToolTipContent from '../../../Common/ToolTipContent/ToolTipContent';
import CurrencyConverter from '../../../CurrencyConverter/CurrencyConverter';
import Loader from "../../../Common/Loader/Loader";
import CommonModal from "../../../Modal/CommonModal";
import AddTipsForm from "../../../AddTipsForm/AddTipsForm";
import { closeHeaderModal, openHeaderModal } from "../../../../actions/siteadmin/modalActions";
import { getHours } from '../../../../helpers/workTimeConversion';
import messages from "../../../../locale/messages";
import accordionArrowIcon from '/public/dashboard/accordionArrowIcon.svg';
import bt from '../../../commonStyle.css';
import s from './PriceSplitUp.css';


const PriceSplitUp = (props) => {
    const {
        data,
        categoryName,
        serviceFee,
        visitFee,
        total,
        subTotal,
        discount,
        currency,
        isOrderPage,
        intl: { formatMessage },
        isTipAmount,
        paymentType,
        tipsAmount,
        isTopRadius,
        isPaymentCompleted,
        fee,
        isMessage
    } = props

    const [selected, setSelected] = useState(false)
    const dispatch = useDispatch()
    const addTipsForm = useSelector(state => state.adminModalStatus.addTipsForm)

    const toggleSelected = () => {
        setSelected(prevState => !prevState);
    }
    const renderSubCategory = (values, index) => {
        let subCategoryName = values?.subCategoryDetails?.name, quantity = values?.totalQuantity,
            minHours = values?.minimumHours, subCategoryBasePrice = isOrderPage ? values?.subCategoryBasePrice : values?.baseFare, price,
            pricingType = isOrderPage ? data?.result?.categoryDetails?.pricingType : data?.result?.pricingType, multiplierValue = values?.multiplierValue
        const timeData = getHours(values?.workedDuration);
        if (pricingType === 'fixed') {
            let totalQuantity = quantity > multiplierValue ? multiplierValue : quantity;
            price = totalQuantity * subCategoryBasePrice;
        } else {
            let totalHours = timeData > minHours ? timeData : minHours;
            price = totalHours * subCategoryBasePrice;
        }

        return (
            <div className={cx(s.pricingSplitUpInnerFlexWrapper, bt.commonSize14, bt.fontWeight400, bt.secondaryColor)} key={index}>
                <div className={s.pricingSplitUpTitle}>
                    <div>
                        <span className={bt.displayInlineBlock}>
                            <span className={bt.displayInlineBlock}>{subCategoryName}&nbsp;</span>
                            <span className={bt.displayInlineBlock}>x&nbsp;</span>
                            <span className={bt.displayInlineBlock}>
                                {pricingType !== 'fixed' ? (
                                    <>
                                        <span className={bt.displayInlineBlock}>{minHours}&nbsp;</span>
                                        <span className={bt.displayInlineBlock}><FormattedMessage {...messages.hoursLabel} /></span>
                                    </>
                                ) : (
                                    <>
                                        {quantity}
                                    </>
                                )}
                            </span>
                        </span>
                    </div>
                </div>
                <span>
                    <CurrencyConverter amount={price} from={currency} />
                </span>
            </div>
        )
    }

    const closeAddTipsModal = () => {
        dispatch(closeHeaderModal('addTipsForm'))
    }

    let subTotalPrice = isOrderPage ? subTotal
        : data?.result?.orderItemsList?.reduce((total, item) => {
            return total + (item.totalBookingFare || 0);
        }, 0);
    let formData = {
        isAdditionalFee: true
    }

    return (
        <div className={cx(bt.commonViewBookingRsBox, isTopRadius ? s.pricingSplitUpBoxTopRadius : isPaymentCompleted ? [bt.space1, bt.spaceTop1] : [s.pricingSplitUpBoxBottomRadius, bt.spaceTop1])}>
            <CommonModal
                title={formatMessage(messages.tips)}
                onHide={() => closeAddTipsModal()}
                modalStatus={addTipsForm}
                titleHidden={true}
            >
                <AddTipsForm data={data} currency={currency} total={total} />
            </CommonModal>
            <p className={cx(bt.commonViewBookingHeading, bt.space2)}>{formatMessage(messages.priceBreakdown)}</p>
            {currency === null &&
                <div className={s.priceSplitUpLoaderContainer}>
                    <Loader type="text" show={true} />
                </div>
            }
            {
                currency && <>
                    {data?.result?.orderItemsList?.length > 0 ?
                        <Accordion defaultActiveKey="0">
                            <Accordion.Toggle eventKey="0" onClick={toggleSelected} className={cx('commonPricingAccordionHeading', s.pricingSplitUpFlexWrapper, bt.commonSize16, bt.fontWeight400, bt.primaryColor)}>
                                <div className={cx(s.pricingSplitUpAccordionHeading, "svgImg")}>
                                    {categoryName}
                                    <span className={'accordionArrow'}>
                                        <img src={accordionArrowIcon} className={cx(selected ? 'accordionArrowUp' : 'accordionArrowDown')} />
                                    </span>
                                </div>
                                <CurrencyConverter amount={subTotalPrice} from={currency} />
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                                <div>
                                    {data?.result?.orderItemsList?.map((item, index) => { return (renderSubCategory(item, index)) })}
                                </div>
                            </Accordion.Collapse>
                        </Accordion> :
                        <div className={cx(s.pricingSplitUpFlexWrapper, bt.commonSize16, bt.fontWeight400, bt.primaryColor, s.pricingSplitUpNoMargin)}>
                            <div className={s.pricingSplitUpTitle}>
                                {categoryName}
                            </div>
                            <span>
                                <CurrencyConverter amount={subTotalPrice} from={currency} />
                            </span>
                        </div>
                    }
                    {visitFee > 0 && (
                        <div className={cx(s.pricingSplitUpFlexWrapper, bt.commonSize16, bt.fontWeight400, bt.primaryColor)}>
                            <div className={cx(s.pricingSplitUpTitle, s.pricingSplitUpTitleBaseline, 'svgImg')}>
                                <ToolTipContent label={formatMessage(messages.visitFeeToolTipContent)} />
                                {formatMessage(messages.travelCharge)}
                            </div>
                            <span>
                                <CurrencyConverter amount={visitFee} from={currency} />
                            </span>
                        </div>
                    )}
                    {serviceFee > 0 && (
                        <div className={cx(s.pricingSplitUpFlexWrapper, bt.commonSize16, bt.fontWeight400, bt.primaryColor)}>
                            <div className={cx(s.pricingSplitUpTitle, s.pricingSplitUpTitleBaseline, 'svgImg')}>
                                <ToolTipContent label={formatMessage(messages.serviceFeeToolTipContent)} />
                                {formatMessage(messages.serviceFee)}
                            </div>
                            <span>
                                <CurrencyConverter amount={serviceFee} from={currency} />
                            </span>
                        </div>
                    )}
                    {discount > 0 && (
                        <div className={cx(s.pricingSplitUpFlexWrapper, bt.commonSize16, bt.fontWeight400, bt.primaryColor)}>
                            <div className={cx(s.pricingSplitUpTitle, s.pricingSplitUpTitleBaseline, 'svgImg', bt.discountForeground)}>
                                <ToolTipContent label={formatMessage(messages.discountToolTipContent)} />
                                {formatMessage(messages.couponDiscount)}
                            </div>
                            <span className={cx(bt.discountForeground, s.pricingSplitUpDiscountAmount)}>
                                -<CurrencyConverter amount={discount} from={currency} />
                            </span>
                        </div>
                    )}
                    {fee > 0 && (
                        <div className={cx(s.pricingSplitUpFlexWrapper, bt.commonSize16, bt.fontWeight400, bt.primaryColor)}>
                            <div className={cx(s.additionPricingSplitUpTitle, 'svgImg', "additionPricingSplitUpTitleRtl")}>
                                <span>{formatMessage(messages.additionalPayment)}</span>
                                <a href={'#'} className={bt.commonLinkWithOutBorder} onClick={(e) => {
                                    e.preventDefault();
                                    dispatch(openHeaderModal('additionalRequest', formData));
                                }}>
                                    <FormattedMessage {...messages.viewText} />
                                </a>
                            </div>
                            <span>
                                <CurrencyConverter amount={fee} from={currency} />
                            </span>
                        </div>
                    )}
                    {paymentType != 1 && isTipAmount && !tipsAmount && (
                        <div className={cx(s.pricingSplitUpFlexWrapper, bt.commonSize16, bt.fontWeight400, bt.primaryColor)}>
                            <div className={s.pricingSplitUpTitle}>
                                {formatMessage(messages.tips)}
                            </div>
                            <a href={'#'} onClick={(e) => {
                                e.preventDefault();
                                dispatch(openHeaderModal('addTipsForm'))
                            }}
                                className={bt.viewAllLink}
                            >
                                <FormattedMessage {...messages.add} />
                            </a>
                        </div>
                    )}
                    {tipsAmount > 0 && (
                        <div className={cx(s.pricingSplitUpFlexWrapper, bt.commonSize16, bt.fontWeight400, bt.primaryColor)}>
                            <div className={s.pricingSplitUpTitle}>
                                {formatMessage(messages.tips)}
                            </div>
                            <span>
                                <CurrencyConverter amount={tipsAmount} from={currency} />
                            </span>
                        </div>
                    )}
                    {total > 0 &&
                        (<><hr className={bt.sectionDividerBorder} />
                            <div className={cx(s.pricingSplitUpFlexWrapper, bt.commonSize16, bt.fontWeight600, bt.primaryColor)}>
                                <div className={s.pricingSplitUpTitle}>
                                    {formatMessage(messages.total)}
                                </div>
                                <span>
                                    <CurrencyConverter amount={total} from={currency} />
                                </span>
                            </div>
                        </>)
                    }
                </>
            }


        </div>
    )
}
export default injectIntl(withStyles(bt, s)(PriceSplitUp));
